import React from 'react';
import './BottomLinks.scss';

interface Props {
  children: React.ReactNode;
}

const BottomLinks = ({ children }: Props) => {
  return <div className="bottom-links">{children}</div>;
};

export default BottomLinks;
